import { Logger, EngineComponentFactory } from "neo-common";
import { ComponentTypes } from "../ComponentTypes";
import { PlayList } from "../Sounds/PlayList";

/**
 * The SoundManager class is used for parsing elements which are representation of playlists and songs.
 * @class SoundManager
 */
export class SoundManager {
    // TODO any
    static PlayLists: { [id: string]: any } = {};

    /**
     * Trace to browser console.
     * @method log
     * @param data any
     * @return void
     */
    private static log(data: any): void {
        if (DEBUG) {
            Logger.debugGroup("SoundManager", data);
        }
    }

    /**
     * Parse songs and playlists.
     * @method parseElements
     * @param node Element
     * @param playList string - optional
     * @return void
     */
    static parseElements(node: Element, playList: string = ""): void {
        if (node != null) {
            var next: Element = node.firstElementChild;

            while (next != null) {
                var cls: string = "";
                if (next.hasAttribute("Class")) {
                    cls = next.getAttribute("Class");
                } else {
                    if (DEBUG) {
                        this.log("WARNING element with name: " + next.nodeName + " has no class");
                    }
                }

                if (cls !== "") {
                    if (EngineComponentFactory.isTypeOf(cls, ComponentTypes.PlayList)) {
                        var element: any = EngineComponentFactory.get(cls);
                        SoundManager.PlayLists[next.nodeName] = element;
                        element.create(next);
                    } else if (EngineComponentFactory.isTypeOf(cls, ComponentTypes.Song)) {
                        var element: any = EngineComponentFactory.get(cls);
                        element.create(next);

                        if (playList !== "") {
                            PlayList.addToPlayList(element);
                        }
                    }
                }
                next = next.nextElementSibling;
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Managers/SoundManager.ts
 **/